export enum MetalsQuoteRequestMaterialType {
    SheetMetal = 'Sheet Metal',
    BarStock = 'Bar Stock',
    SquareTube = 'Square Tube',
    CoilSteel = 'Coil Steel',
}
